import { get } from "jquery";
import api from "./request";

const subscriptionClassService = {
  // Récupérer toutes les classes
  getAll: async () => {
    try {
      const response = await api.get("/classes");
      return {
        success: true,
        data: response.data?.data || [],
        message: response.data?.message || "Classes récupérées avec succès",
      };
    } catch (error) {
      console.error("Erreur lors de la récupération des classes:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la récupération des classes",
      };
    }
  },

  // Récupérer les classes d'un abonnement
  getClasses: async (subscriptionSlug) => {
    try {
      const response = await api.get(
        `/subscriptions/${subscriptionSlug}/classes`
      );
      return {
        success: true,
        data: response.data?.data || [],
        message: response.data?.message || "Classes récupérées avec succès",
      };
    } catch (error) {
      console.error("Erreur lors de la récupération des classes:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la récupération des classes",
      };
    }
  },

  // Ajouter une classe à l'abonnement
  addClass: async (subscriptionSlug, classData) => {
    try {
      const response = await api.post(
        `/subscriptions/${subscriptionSlug}/classes`,
        classData
      );
      return {
        success: true,
        data: response.data?.data || {},
        message: response.data?.message || "Classe ajoutée avec succès",
      };
    } catch (error) {
      console.error("Erreur lors de l'ajout de la classe:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de l'ajout de la classe",
      };
    }
  },

  // Récupérer les détails d'une classe dans l'abonnement
  getClass: async (subscriptionSlug, classSlug) => {
    try {
      const response = await api.get(
        `/subscriptions/${subscriptionSlug}/classes/${classSlug}`
      );
      return {
        success: true,
        data: response.data?.data || {},
        message: response.data?.message || "Détails de la classe récupérés",
      };
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des détails de la classe:",
        error
      );
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la récupération des détails",
      };
    }
  },

  // Mettre à jour une classe dans l'abonnement
  updateClass: async (subscriptionSlug, classSlug, classData) => {
    try {
      const response = await api.put(
        `/subscriptions/${subscriptionSlug}/classes/${classSlug}`,
        classData
      );
      return {
        success: true,
        data: response.data?.data || {},
        message: response.data?.message || "Classe mise à jour avec succès",
      };
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la classe:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la mise à jour de la classe",
      };
    }
  },

  // Retirer une classe de l'abonnement
  removeClass: async (subscriptionSlug, classSlug) => {
    try {
      const response = await api.delete(
        `/subscriptions/${subscriptionSlug}/classes/${classSlug}`
      );
      return {
        success: true,
        message: response.data?.message || "Classe retirée avec succès",
      };
    } catch (error) {
      console.error("Erreur lors de la suppression de la classe:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la suppression de la classe",
      };
    }
  },

  // Synchroniser les élèves de la classe avec l'abonnement
  syncStudents: async (subscriptionSlug, classSlug) => {
    try {
      const response = await api.post(
        `/subscriptions/${subscriptionSlug}/classes/${classSlug}/sync-students`
      );
      return {
        success: true,
        data: response.data?.data || {},
        message: response.data?.message || "Synchronisation des élèves réussie",
      };
    } catch (error) {
      console.error("Erreur lors de la synchronisation des élèves:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la synchronisation des élèves",
      };
    }
  },

  // Récupérer les classes disponibles pour l'abonnement
  getAvailableClasses: async (subscriptionSlug) => {
    try {
      const response = await api.get(
        `/subscriptions/${subscriptionSlug}/classes/available`
      );
      return {
        success: true,
        data: response.data?.data || [],
        meta: response.data?.meta || {},
        message: response.data?.message || "Classes disponibles récupérées",
      };
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des classes disponibles:",
        error
      );
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la récupération des classes disponibles",
      };
    }
  },

  // Récupérer les statistiques des classes
  getClassesStats: async (subscriptionSlug) => {
    try {
      const response = await api.get(
        `/subscriptions/${subscriptionSlug}/classes/stats`
      );
      return {
        success: true,
        data: response.data?.data || {},
        message:
          response.data?.message || "Statistiques des classes récupérées",
      };
    } catch (error) {
      console.error("Erreur lors de la récupération des statistiques:", error);
      throw {
        success: false,
        message:
          error.response?.data?.message ||
          "Erreur lors de la récupération des statistiques",
      };
    }
  },
};

export default subscriptionClassService;
